/**
 * Square icon button used across the sidebar header and panels.
 * `label` is required and doubles as the accessible name and the tooltip.
 */
export default function IconButton({
  label,
  children,
  active = false,
  size = 'md',
  disabled = false,
  className = '',
  ...props
}) {
  // 44px minimum on touch, compact from `lg` up where a pointer is assumed.
  //
  // `brand` is the sidebar header row: it has to hold three controls plus the
  // logo in a 300-320px column, so it steps down to 40px from `sm` up (still
  // above the 40px tap-target floor) instead of the 36px `md` used elsewhere.
  const dimensions =
    size === 'sm'
      ? 'h-11 w-11 rounded-lg lg:h-8 lg:w-8'
      : size === 'brand'
        ? 'h-11 w-11 rounded-xl sm:h-10 sm:w-10'
        : 'h-11 w-11 rounded-xl lg:h-9 lg:w-9';

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      aria-pressed={active || undefined}
      className={`z2-glow-hover relative inline-flex items-center justify-center ${dimensions} disabled:cursor-not-allowed disabled:opacity-50 ${
        disabled ? '' : 'active:scale-[0.96]'
      } ${
        active
          ? 'bg-brand-soft text-accent'
          : 'text-ink-2 hover:bg-surface-3 hover:text-accent'
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
